import { render, staticRenderFns } from "./deleteNote.vue?vue&type=template&id=47716541&"
import script from "./deleteNote.vue?vue&type=script&lang=js&"
export * from "./deleteNote.vue?vue&type=script&lang=js&"
import style0 from "./deleteNote.vue?vue&type=style&index=0&id=47716541&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports